import {GET, POST} from '../index'

export const getJobList = (data) => {
  return GET('/job/list', data)
}
export const addJob = (data) => {
  return POST('/job/store', data)
}
export const updateJob = (data) => {
  return POST('/job/update', data)
}
export const delJob = (id) => {
  return POST(`job/${id}/destroy`)
}

export const toggleStatus = (id) => {
  return POST(`job/${id}/switch`)
}

export const setSort = (data) => {
  return POST(`job/setSort`, data)
}



// WEBPACK FOOTER //
// ./src/api/job/index.js